<template>
    <div>
        <ModelosRelatorioDialog :dialog="dialogModeloRelatorioDialog" :relm_id="relm_id" :rela_id="model.rela_id"
            :relatorio="model" @dialogCloseModelosRelatorioDialog="dialogCloseModelosRelatorioDialog" />

        <v-dialog v-model="isDialog" :max-width="800">
            <v-card>
                <v-card-title class="bg-header grey lighten-4">
                    <span class="text-h6 font-weight-bold grey--text text--darken-3">
                        <v-icon left color="primary">mdi-file-document-edit-outline</v-icon>
                        Relatório
                    </span>

                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogCloseRelatorioDialog">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pt-5 px-4 pb-3">
                    <v-row v-if="isNovo == false">
                        <v-col cols="12">
                            <v-text-field outlined dense v-model="model.rela_descricao" label="Relatório" hide-details
                                type="text" readonly />
                        </v-col>
                    </v-row>

                    <v-row class="mt-2" v-if="isNovo">
                        <v-col cols="12">
                            <v-file-input label="Upload Relatório" v-model="report" accept=".rpt" hide-details outlined
                                dense prepend-inner-icon="mdi-cloud-upload-outline" prepend-icon="">
                                <template v-slot:selection>
                                    {{ report ? report.name : '' }}
                                </template>
                            </v-file-input>
                        </v-col>
                    </v-row>

                    <v-row v-if="isNovo">
                        <v-col cols="12">
                            <div class="d-flex justify-end">
                                <v-btn color="success" class="text-none" size="small" @click="saveClick">
                                    <v-icon left small>mdi-content-save-check</v-icon>
                                    Salvar
                                </v-btn>
                            </div>
                        </v-col>
                    </v-row>

                    <v-divider class="my-4"></v-divider>

                    <v-row v-if="isNovo == false">
                        <v-col cols="12">
                            <div class="d-flex justify-end">
                                <v-btn color="primary" class="text-none" size="small" @click="novoRelmodelosClick">
                                    Novo Modelo
                                </v-btn>
                            </div>
                        </v-col>
                    </v-row>

                    <v-data-table :headers="headers" :items="relmodelos" class="elevation-1 teste" :loading="loading" dense
                        no-data-text="Nenhum modelo encontrado">

                        <template v-slot:[`item.relm_versionar`]="{ item }">
                            <span>
                                {{ item.relm_versionar ? 'Sim' : '' }}
                            </span>
                        </template>

                        <template v-slot:[`item.created_at`]="{ item }">
                            <span>
                                {{ item.created_at ? new Date(item.created_at).toLocaleString('pt-BR') :
                                    '-' }}
                            </span>
                        </template>

                        <template v-slot:[`item.updated_at`]="{ item }">
                            <span>
                                {{ item.created_at ? new Date(item.updated_at).toLocaleString('pt-BR') :
                                '-' }}
                            </span>
                        </template>

                        <template v-slot:[`item.actions`]="{ item }">
                            <v-btn text :href="item.relm_url_report" icon color="primary">
                                <v-icon>mdi-download</v-icon>
                            </v-btn>

                            <v-btn class="text-none" size="small" text color="primary" icon
                                @click="editarRelmodelosClick(item)">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn class="text-none" size="small" text color="error" icon
                                @click="excluirRelmodelosClick(item)">
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>

                    <div class="mt-5">ID: {{ model.rela_id }}</div>
                </v-card-text>
            </v-card>
        </v-dialog>

    </div>
</template>
<style scoped>
.teste {
	white-space: nowrap
}
</style>
<script>
import { RelmodelosService } from '../../services/reports/relmodelosService.js';
import { RelatoriosService } from '../../services/reports/relatoriosService.js';
import ModelosRelatorioDialog from './ModelosRelatorioDialog.vue'

const relmodelosService = new RelmodelosService();
const relatoriosService = new RelatoriosService();

export default {
    props: {
        rela_id: String,
        dialog: Boolean,
    },
    components: {
        ModelosRelatorioDialog
    },
    data: () => ({
        loading: false,
        isNovo: false,
        relm_id: "",
        dialogModeloRelatorioDialog: false,
        model: {
            rela_id: '',
            rela_descricao: ''
        },
        report: null,
        headers: [
            { text: 'Modelo', value: 'relm_descricao', align: 'start' },
            { text: 'Versionamento', value: 'relm_versionar', align: 'start' },
            { text: 'Criado em:', value: 'created_at', align: 'start' },
            { text: 'Editado em:', value: 'updated_at', align: 'start' },
            { text: 'Ação', value: 'actions', align: 'center' },
        ],
        relmodelos: [],
    }),
    methods: {
        async editarRelmodelosClick(relmodelos) {
            this.relm_id = relmodelos.relm_id;
            this.dialogModeloRelatorioDialog = true;
        },
        async novoRelmodelosClick() {
            this.relm_id = "";
            this.dialogModeloRelatorioDialog = true;
        }, async excluirRelmodelosClick(relmodelos) {
            try {
                const confirmou = await this.$root.$confirm(
                    'Exclusão',
                    'Deseja realmente excluir?',
                );

                if (!confirmou) return;

                const confirmou2 = await this.$root.$confirm_alert(
                    'Confirmação',
                    'Tem certeza que deseja prosseguir com a exclusão?',
                );
                if (!confirmou2) return;

                await relmodelosService.remove(relmodelos.rela_id, relmodelos.relm_id);
                this.carregarModelos();

                this.$store.dispatch('showSuccess', 'Excluído com sucesso!')
            } catch (error) {
                this.$store.dispatch('showError', error)
            }
        },
        async saveClick() {
            if (this.validaSalvar() == false) return;

            try {
                this.$isLoading(true);

                let form = new FormData()
                form.append('report', this.report)

                this.model = await relatoriosService.create(form);
                this.isNovo = false;
                this.carregarModelos();

                this.$store.dispatch('showSuccess', 'Salvo com sucesso!')
            } catch (error) {
                this.$store.dispatch('showError', error)
            } finally {
                this.$isLoading(false);
            }
        },
        validaSalvar() {
            if (!this.report) {
                this.$store.dispatch('showError', 'Escolha o relatório rpt!')
                return false
            }

            var nomeArquivo = this.report.name
            var extensaoArquivo = nomeArquivo.substring(nomeArquivo.length - 3, nomeArquivo.length).toLowerCase()

            if (extensaoArquivo != 'rpt') {
                this.$store.dispatch('showError', 'Arquivo inválido, deve ser .rpt!')
                return false
            }
            return true
        },
        dialogCloseRelatorioDialog() {
            this.$emit('dialogCloseRelatorioDialog')
        },
        dialogCloseModelosRelatorioDialog() {
            this.dialogModeloRelatorioDialog = false;
            this.carregarModelos();
        },
        async carregarModelos() {
            this.loading = true;
            try {
                this.relmodelos = await relmodelosService.getAll(this.model.rela_id);
            } catch (error) {
                this.$store.dispatch('showError', error)
            } finally {
                this.loading = false;
            }
        }
    },
    computed: {
        isDialog: {
            get() {
                return this.dialog
            },
            set() {
                this.dialogCloseRelatorioDialog();
            }
        }
    },
    watch: {
        async dialog() {
            this.model = {};
            this.report = null;
            this.relmodelos = [];
            this.isNovo = true;

            if (this.rela_id) {
                this.isNovo = false;
                this.model = await relatoriosService.get(this.rela_id);
                this.carregarModelos();
            }
        }
    }
}
</script>
